// App version shown on the About page.
// Bumped by one step in every release PR (OR-141). Keep package.json "version" in step.
export const APP_VERSION = '1.3';
